export type NameTranslation = { localeCode: string; translatedName: string };

export type TranslationsDelta = {
  translations: NameTranslation[];
  removeTranslations: string[];
};

export function computeTranslationsDelta(
  original: NameTranslation[],
  current: NameTranslation[],
): TranslationsDelta {
  const originalByLocale = new Map(original.map(t => [t.localeCode, t.translatedName]));
  const currentLocaleCodes = new Set(
    current.map(t => t.localeCode).filter(localeCode => localeCode.trim() !== ""),
  );

  const removeTranslations = original
    .map(t => t.localeCode)
    .filter(localeCode => !currentLocaleCodes.has(localeCode));

  const translations: NameTranslation[] = [];
  const seenLocales = new Set<string>();
  for (const t of current) {
    if (t.localeCode.trim() === "" || t.translatedName.trim() === "") continue;
    if (seenLocales.has(t.localeCode)) continue;
    seenLocales.add(t.localeCode);

    const originalName = originalByLocale.get(t.localeCode);
    if (originalName === undefined || originalName !== t.translatedName) {
      translations.push(t);
    }
  }

  return { translations, removeTranslations };
}
